import Script from 'next/script'

import { env } from '@/shared/config'

export function GoogleTagManagerScript() {
    if (!env.GOOGLE_TAG_MANAGER_APP_ID) {
        return null
    }

    return (
        <Script
            id="google-tag-manager-script"
            type="text/javascript"
            src={`https://www.googletagmanager.com/gtm.js?id=${env.GOOGLE_TAG_MANAGER_APP_ID}`}
            strategy="afterInteractive"
        />
    )
}
